var _excluded = ["menuId", "minLevel", "maxLevel", "mode", "MenuItemWrapper", "MenuItemLink", "MenuItemLinkElement", "className", "additionalClassName", "onClickFunction", "alterUrlFunction"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import Menu from '../../Drupal/Entity/Menu';
import { RecursiveMenuMode } from './types';
import MenuItemLinkElementDefault, { MenuItemLinkDefault, MenuItemWrapperDefault } from './index.default';
import MenuLinkCollapsibleElement from './index.collapsible';
export var RecursiveMenuRenderer = function RecursiveMenuRenderer(_ref) {
  var menuId = _ref.menuId,
    _ref$minLevel = _ref.minLevel,
    minLevel = _ref$minLevel === void 0 ? 1 : _ref$minLevel,
    _ref$maxLevel = _ref.maxLevel,
    maxLevel = _ref$maxLevel === void 0 ? 10 : _ref$maxLevel,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? RecursiveMenuMode.full : _ref$mode,
    _ref$MenuItemWrapper = _ref.MenuItemWrapper,
    MenuItemWrapper = _ref$MenuItemWrapper === void 0 ? MenuItemWrapperDefault : _ref$MenuItemWrapper,
    _ref$MenuItemLink = _ref.MenuItemLink,
    MenuItemLink = _ref$MenuItemLink === void 0 ? MenuItemLinkDefault : _ref$MenuItemLink,
    _ref$MenuItemLinkElem = _ref.MenuItemLinkElement,
    MenuItemLinkElement = _ref$MenuItemLinkElem === void 0 ? MenuItemLinkElementDefault : _ref$MenuItemLinkElem,
    className = _ref.className,
    _ref$additionalClassN = _ref.additionalClassName,
    additionalClassName = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
    _ref$onClickFunction = _ref.onClickFunction,
    onClickFunction = _ref$onClickFunction === void 0 ? function () {} : _ref$onClickFunction,
    _ref$alterUrlFunction = _ref.alterUrlFunction,
    alterUrlFunction = _ref$alterUrlFunction === void 0 ? function (url) {
      return url;
    } : _ref$alterUrlFunction,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var currentPage = useSelector(function (state) {
    return state.getIn(['router', 'location', 'pathname'], '');
  });
  var RecursiveMenuClassnames = c('RecursiveMenu', className);

  // buildMenu is a recursive function to render a full menu tree.
  var buildMenu = function buildMenu(item, parentIsActive, parentIsActiveOrTrail) {
    var _item$link$options, _item$link$options$at;
    var _item$link = item.link,
      title = _item$link.title,
      url = _item$link.url,
      description = _item$link.description;
    var itemClassNames = (_item$link$options = item.link.options) === null || _item$link$options === void 0 ? void 0 : (_item$link$options$at = _item$link$options.attributes) === null || _item$link$options$at === void 0 ? void 0 : _item$link$options$at.class;
    var active = item.link.url === currentPage;
    var trail = currentPage.startsWith(item.link.url) && !(item.link.url === currentPage);
    var RecursiveMenuItemClassnames = c('RecursiveMenu__item', {
      'RecursiveMenu__item--active': active
    }, {
      'RecursiveMenu__item--trail': trail
    }, additionalClassName, itemClassNames);

    // minLevel allows us to skip rendering an x amount of layers.
    // We go straight to the next layer, withouth rendering anything.
    if (minLevel > 0 && item.depth < minLevel) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return item.subtree.map(function (_item) {
        return buildMenu(_item, mode === RecursiveMenuMode.breadcrumb ? active : undefined, mode === RecursiveMenuMode.intranet ? active || trail : undefined);
      });
    }

    // Breadcrumb mode
    // Only render the current tree we're on, and the children of the active node.
    // Almost like breadcrumbs, but also show the upcoming crumbs.
    if (mode === RecursiveMenuMode.breadcrumb && !parentIsActive && !active && !trail) {
      return null;
    }

    // Intranet mode
    // If the current node's parent is not the active page or in trail, don't render.
    if (mode === RecursiveMenuMode.intranet && parentIsActiveOrTrail === false) {
      return null;
    }

    // The default return renders our MenuItem and renders any possible children, recursively.
    return /*#__PURE__*/React.createElement(MenuItemLink, _extends({
      data: item.link.title,
      className: RecursiveMenuItemClassnames,
      key: "".concat(title, ":").concat(url)
    }, otherProps), /*#__PURE__*/React.createElement(MenuItemLinkElement, _extends({
      item: item,
      active: active,
      trail: trail,
      url: url,
      title: title,
      description: description,
      alterUrlFunction: alterUrlFunction,
      onClickFunction: onClickFunction,
      minLevel: minLevel,
      maxLevel: maxLevel,
      mode: mode,
      buildMenu: buildMenu,
      MenuItemWrapper: MenuItemWrapper
    }, otherProps)));
  };
  return /*#__PURE__*/React.createElement("nav", {
    className: RecursiveMenuClassnames
  }, /*#__PURE__*/React.createElement(Menu, {
    id: menuId
  }, function (items) {
    return /*#__PURE__*/React.createElement(MenuItemWrapper, _extends({
      level: 0,
      buildMenu: buildMenu
    }, otherProps), items.toJS());
  }));
};
var RecursiveMenu = function RecursiveMenu(props) {
  return /*#__PURE__*/React.createElement(RecursiveMenuRenderer, props);
};
export var RecursiveMenuCollapsible = function RecursiveMenuCollapsible(props) {
  return /*#__PURE__*/React.createElement(RecursiveMenuRenderer, _extends({
    className: "RecursiveMenu--Collapsible",
    MenuItemLinkElement: MenuLinkCollapsibleElement
  }, props));
};
export default RecursiveMenu;